export default function updateColumnsShowAttribute(
    columns,
    multiSelectDropownOptionsArr,
    newObj,
    selectedValues
) {
    let displayOptionsList = [];
    selectedValues.forEach((v) => {
        if (v?.children) {
            v.children.forEach((vc) => displayOptionsList.push(vc.value));
        } else if (v?.id) {
            displayOptionsList.push(v.value);
        }
    });

    let allShowHideColumnsList = [];
    multiSelectDropownOptionsArr?.forEach((md) => {
        if (md?.children) {
            allShowHideColumnsList.push(...md.children);
        } else if (md?.parent) {
            allShowHideColumnsList.push(md.parent);
        }
    });

    allShowHideColumnsList.forEach((columnName) => {
        const indexOfColumn = columns.findIndex(
            (fi) => fi.headCellProps.text === columnName
        );
        newObj[indexOfColumn].show = displayOptionsList.includes(columnName);
    });
}
